"use strict";
/**
 * @file Created on 27.05.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var NotificationDoc_1 = require("../NotificationDoc");
/**
 * @author Tomas Leity
 */


var NChangedGroupOfSites =
/*#__PURE__*/
function (_NotificationDoc_1$No) {
  _inherits(NChangedGroupOfSites, _NotificationDoc_1$No);

  /**
   * @param productId
   * @param productName
   * @param newGroupOfSitesId
   * @param newGroupOfSitesName
   * @param oldGroupOfSitesId
   * @param oldGroupOfSitesName
   */
  function NChangedGroupOfSites(productId, productName, newGroupOfSitesId, newGroupOfSitesName, oldGroupOfSitesId, oldGroupOfSitesName) {
    var _this;

    _classCallCheck(this, NChangedGroupOfSites);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NChangedGroupOfSites).call(this));
    _this.productId = productId;
    _this.productName = productName;
    _this.newGroupOfSitesId = newGroupOfSitesId;
    _this.newGroupOfSitesName = newGroupOfSitesName;
    _this.oldGroupOfSitesId = oldGroupOfSitesId;
    _this.oldGroupOfSitesName = oldGroupOfSitesName;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(NChangedGroupOfSites, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new NChangedGroupOfSites(mat.productId, mat.productName, mat.newGroupOfSitesId, mat.newGroupOfSitesName, mat.oldGroupOfSitesId, mat.oldGroupOfSitesName);
    }
  }]);

  return NChangedGroupOfSites;
}(NotificationDoc_1.NotificationDoc);

exports.NChangedGroupOfSites = NChangedGroupOfSites;

NChangedGroupOfSites.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(NChangedGroupOfSites.name);
  return {
    productId: builder.id('productId'),
    productName: builder.str('productName'),
    newGroupOfSitesId: builder.id('newGroupOfSitesId'),
    newGroupOfSitesName: builder.str('newGroupOfSitesName'),
    oldGroupOfSitesId: builder.id('oldGroupOfSitesId'),
    oldGroupOfSitesName: builder.str('oldGroupOfSitesName')
  };
}();